<script lang="ts" module>
  import type { Filter } from '../../stores';

  export interface SelectFilterProps {
    label: string;
    items: (Filter & { type: 'distinct' })['items'];
    values?: string[];
    onValueChange?: (details: Parameters<NonNullable<SelectRootProps['onValueChange']>>[0]) => void;
  }
</script>

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { Select, SelectControl, SelectContent, SelectItem, type SelectRootProps } from '@agapi/ui/select';

  import * as m from '$lib/parachute/messages';

  let { label, items, values, onValueChange }: SelectFilterProps = $props();

  let selectRef = $state<any>();
  let seed = $state(0);

  export const refresh = () => {
    seed += 1;
  }

  export const setValue = (value: string[]) => {
    selectRef?.setValue(value);
  }
</script>

{#key seed}
  <Select
    bind:this={selectRef}
    multiple
    items={items}
    onValueChange={onValueChange}
    defaultValue={values}
    >
    <SelectControl
      controlStyles={css.raw({ display: 'flex', flex: 1 })}
      buttonStyles={{ flex: 1, fontWeight: 'bold' }}
      triggerLabel={{ categories: m.categories(), brand_name: m.brands() }[label as 'categories' | 'brand_name']}
      badge
    />
    <SelectContent positionerStyles={css.raw({ position: 'relative', zIndex: '9999!' })}>
      {#each items as item}
        <SelectItem item={{ ...item, label: item.label.split('|').pop()?.trim() ?? item.label }} />
      {/each}
    </SelectContent>
  </Select>
{/key}
